module.exports = __webpack_public_path__ + "img/qb.68a12cf0.png";